/**
 * Resize/compress an image File to a base64 data URL no wider than
 * `maxDim` px on the long edge, JPEG-encoded at the given quality.
 * Returns a `data:image/jpeg;base64,...` string. Keeps the file under
 * the backend's 5MB cap even when the phone shoots 12MP.
 */
export async function compressImageToDataUrl(file, { maxDim = 1280, quality = 0.78 } = {}) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error || new Error("read failed"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("image decode failed"));
      img.onload = () => {
        const ratio = Math.min(1, maxDim / Math.max(img.width, img.height));
        const w = Math.round(img.width * ratio);
        const h = Math.round(img.height * ratio);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        const dataUrl = canvas.toDataURL("image/jpeg", quality);
        resolve(dataUrl);
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
